import React, { Component } from 'react';
import Subtitle from "./subtitle";
import Title from "./title";

export default class Home extends Component {
    render() {
        return (
            <div ref={this.props.element}>
                <div ref={this.props.refs.Home} id="home" className="intro bg-image">
                    <div className="intro-content">
                        <div className="intro-center">
                            <Title />
                            <Subtitle />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}